// Characters no common file system accepts in a name.
const RESERVED = '\\/:*?"<>|';

// Also control and text-direction characters, which could disguise the
// extension in a save dialog.
const isUnsafe = (char: string) => {
  const code = char.codePointAt(0) ?? 0;
  return (
    RESERVED.includes(char) ||
    code < 0x20 ||
    code === 0x7f ||
    (code >= 0x202a && code <= 0x202e) ||
    (code >= 0x2066 && code <= 0x2069)
  );
};

// Matches the repo's other blob downloads: revoking on the same tick as the
// click can cancel the download before the browser has read the blob.
const REVOKE_DELAY_MS = 100;

export const proposalFileName = (proposalName: string, stateLabel: string) => {
  const safeName = Array.from(proposalName, (char) =>
    isUnsafe(char) ? "-" : char
  ).join("");
  return `${safeName} - ${stateLabel}.pdf`;
};

// Fetched to a blob so the name applies even when the document is served from
// another origin, where an anchor's download attribute is ignored.
export const downloadFile = async (url: string, fileName: string) => {
  const response = await fetch(url);
  if (!response.ok) throw new Error(`Download failed: ${response.status}`);
  const objectUrl = URL.createObjectURL(await response.blob());
  const link = document.createElement("a");
  link.href = objectUrl;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(objectUrl), REVOKE_DELAY_MS);
};
